<template>
    <div class="lg:p-12 bg-gray-100 rounded p-4">
        <h2 class="text-3xl font-bold text-center text-themeColor mb-4">
            {{ $t('auth.reset_password.title') }}
        </h2>

        <b-loading
            :is-full-page="true"
            v-model="loading"
            :can-cancel="false"
        ></b-loading>

        <div class="mb-4">
            <label
                class="block text-gray-700 text-base font-bold mb-2"
                for="email"
            >
                {{ $t('account.email') }}
            </label>
            <input
                id="email"
                v-model="email"
                autocomplete="email"
                autofocus
                class="appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="email"
                placeholder="patrickmartin@domaine.fr"
                required
                type="email"
            />
        </div>
        <p
            v-if="isSubmit && mailMessage"
            class="has-text-danger font-bold text-center is-size-7 pb-2"
        >
            {{ mailMessage }}
        </p>
        <div class="mb-4">
            <label
                class="block text-gray-700 text-base font-bold mb-2"
                for="password"
            >
                {{ $t('auth.reset_password.password') }}
            </label>

            <input
                id="password"
                v-model="password"
                autocomplete="current-password"
                class="appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="password"
                :placeholder="$t('auth.reset_password.password')"
                required
                type="password"
            />
        </div>

        <p
            v-if="isSubmit && passwordMessage"
            class="has-text-danger font-bold text-center is-size-7"
        >
            {{ passwordMessage }}
        </p>

        <div class="mb-4">
            <label
                class="block text-gray-700 text-base font-bold mb-2"
                for="confirmPassword"
            >
                {{ $t('auth.reset_password.confirm_password') }}
            </label>

            <input
                id="confirmPassword"
                v-model="confirmPassword"
                autocomplete="current-password"
                class="appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="confirmPassword"
                :placeholder="$t('auth.reset_password.confirm_password')"
                required
                type="password"
            />
        </div>
        <div class="mt-5">
            <button
                v-show="!loading"
                class="text-base font-bold text-center bg-themeColor text-white hover-bg-secondaryColor rounded w-full py-3"
                @click.prevent="resetPwd"
            ><span
            ></span>
                {{ $t('auth.reset_password.submit') }}
            </button>

          <button
              v-show="loading"
              class="btn btn-primary btn-user btn-block waves-effect waves-themed"
              disabled="disabled"
              type="button"
          >
                                        <span
                                            aria-hidden="true"
                                            class="spinner-border spinner-border-sm"
                                            role="status"
                                        ></span>
            {{ $t('auth.reset_password.submit') }}
          </button>
        </div>

        <div v-if="isSubmit && successMessage">
            <p class="has-text-danger font-bold text-center is-size-7">
                {{ successMessage }}
            </p>
        </div>
    </div>

</template>

    <style scoped>
        .h2 {
            margin: 0.5em 0 1em 0;
        }
    </style>

    <script>
        import { mapActions } from 'vuex'

        export default {
            name: 'PasswordReset',
            data: function() {
                return {
                    email: '',
                    password: '',
                    confirmPassword: '',
                    isSubmit: false,
                    loading: false,
                    mailMessage: '',
                    passwordMessage: '',
                    successMessage: '',
                    mailregExp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                    tokenResetPwd: ''
                }
            },
            computed: {
                messagePasswordMismatch() {
                    return this.$t('error.validation.password_mismatch')
                },
                messageTitle() {
                    return this.$t('error.title')
                }
            },
            created() {
                this.tokenResetPwd = this.$route.params.token
            },
            methods: {
                ...mapActions('auth', ['resetPassword']),
                resetPwd: function() {
                    // this.loading = true
                    this.isSubmit = true
                    this.validMail(this.email)
                    this.validPassword(this.password, this.confirmPassword)
                    !this.mailMessage && !this.passwordMessage
                        ? this.resetPassword({
                              email: this.email,
                              password: this.password,
                              token_reset_password: this.tokenResetPwd
                          })
                              .then(() => {
                                  this.successMessage = this.$t(
                                      'auth.reset_password.success_message'
                                  )
                                  this.loading = false
                              })
                              .finally(() => {
                                  this.$router.push('/login')
                              })
                              .catch(error => {
                                  this.loading = false
                                  error[
                                      'password_mismatch'
                                  ] = this.errorPasswordMismatch
                                  error['title'] = this.errorTitle
                                  this.$store.dispatch('dispatchError', error)
                              })
                        : (this.loading = false)
                },
                // vérifie la confirmation du mot de passe (correspondance entre les deux mots de passes saisies)
                validPassword(pwd, confirmpwd) {
                    if (!pwd) {
                        this.passwordMessage = this.$t(
                            'error.validation.required'
                        )
                    } else if (pwd !== confirmpwd) {
                        this.passwordMessage = this.$t(
                            'error.validation.password_mismatch'
                        )
                    } else {
                        this.passwordMessage = ''
                    }
                },
                // vérifie la saisie du champ email
                validMail(email) {
                    if (!email) {
                        this.mailMessage = this.$t('error.validation.required')
                    } else if (!this.mailregExp.test(email)) {
                        this.mailMessage = this.$t(
                            'error.validation.mail_valid'
                        )
                    } else {
                        this.mailMessage = ''
                    }
                }
            },
            mounted() {}
        }
    </script>
</template>
